import type { I18n } from '@lingui/core';

import CatEmail from '@rover/react-lib/src/images/marketing-opt-in/cat-email.png';
import CatEmailSms from '@rover/react-lib/src/images/marketing-opt-in/cat-email-sms.png';
import CatEmailWhatsapp from '@rover/react-lib/src/images/marketing-opt-in/cat-email-whatsapp.png';
import DogEmail from '@rover/react-lib/src/images/marketing-opt-in/dog-email.png';
import DogEmailSms from '@rover/react-lib/src/images/marketing-opt-in/dog-email-sms.png';
import DogEmailWhatsapp from '@rover/react-lib/src/images/marketing-opt-in/dog-email-whatsapp.png';

import { buildVariationContent, MARKETING_OPT_IN, VariationContent } from './constants.common';
import { MarketingOptInVariationKey } from './types';

export type { VariationContent };
export { MARKETING_OPT_IN };

export const getVariationContent = (
  variationKey: MarketingOptInVariationKey,
  i18n: I18n
): VariationContent =>
  buildVariationContent(
    { DogEmail, DogEmailSms, DogEmailWhatsapp, CatEmail, CatEmailSms, CatEmailWhatsapp },
    variationKey,
    i18n
  );
